export const GEO_LOCATIONS_URL = "jmis/geo_locations";
export const LOG_STREAMER_URL = "userpref/log-streamer/subscription/*";
export const JPD_READINESS_URL = "jmis/routing_policy/jpd_readiness";
export const PLUGIN_STATUS_URL = "jmis/getPluginStatus";
export const JPD_SSO_ENABLED_URL = "jes/jpd-sso-enabled";
export const SINGLE_FAILOVER_URL = "jmis/singleFailOverUrl/*";
export const LOG_STREAMER_DISABLE_TEMPORARY =
  "userpref/log-streamer/disable/subscription/*";
export const LOG_STREAMER_TYPES = "userpref/log-streamer/types/*";
export const LOG_SHIPPING_ENROLLMENT = "subscriptions/logShippingEnrollment";
export const SSL_VALIDATE = "jmis/ssl/validate/*";
export const SSL_SUBMIT = "jmis/ssl/submit/*";
export const SSL_RENEW = "jmis/ssl/renew/*";
export const SSL_MANAGE = "jmis/ssl/manage_domains/*";
export const SSL_DELETE = "jmis/ssl/delete/*";
export const DNS_ROUTING_POLICY_CREATE = "jmis/routing_policy";
export const DNS_ROUTING_POLICY_UPDATE = "jmis/routing_policy/:uuid";
export const DNS_ROUTING_POLICY_DISABLE = "jmis/routing_policy/:uuid/disable";
export const ENABLE_CONFIG_TRANSFER = "jmis/installPlugin";
export const DISABLE_CONFIG_TRANSFER = "jmis/uninstallPlugin";
export const PLATFORM_SSO_ACCESS = "subscriptions/*/platformSsoAccess";
export const SAML_ORGANIZATIONS = "subscriptions/*/organizations";
export const SAML_ORGANIZATION_BY_ID = "subscriptions/*/organizations/:uuid";
export const SP_CERTIFICATE = "sso/sp-certificate";
export const DOMAINS = "subscriptions/*/domains";
export const DOMAIN_VERIFICATION = "subscriptions/*/domains/:domain";
export const DOMAIN_VERIFY = "subscriptions/*/domains/:domain/verify";
export const DOMAIN_VERIFICATION_DELETE =
  "subscriptions/*/domains/:domain/:method/:uuid";
